export enum DoorType {
    Indeterminate = 0,
    EntryDoor = 1,
    PatioDoor = 2,
    StormDoor = 3,
    SecurityDoor = 4,
    PetDoor = 5,
}

